/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, ElementRef, Inject, Input, NgZone, Optional } from "@angular/core";
import { ANIMATION_MODULE_TYPE } from "@angular/platform-browser/animations";

import { ɵNzTabsInkBarDirective } from "ng-zorro-antd/tabs";
import { UiTabPositionMode } from "../models/tab.models";

@Directive({
  selector: "ui-tabs-ink-bar, [ui-tabs-ink-bar]",
})
export class UiTabsInkBarDirective extends ɵNzTabsInkBarDirective {
  @Input() public position: UiTabPositionMode = "horizontal";
  @Input() public animated = true;

  public constructor(elementRef: ElementRef<HTMLElement>, ngZone: NgZone, @Optional() @Inject(ANIMATION_MODULE_TYPE) public animationMode?: string) {
    super(elementRef, ngZone, animationMode);
  }
}
